import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
//import { AdminServiceService } from '../../service/admin-service.service';
import { AppConfig } from '../../app.configsettings';
import { ToastrService } from 'ngx-toastr';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
declare const closeFullscreen: any;
import { AppOfflineStore } from '../../app.offlineService';
import { AuthService } from '../../Services/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentManagementNavigatorComponent } from './content-management-navigator/content-management-navigator.component';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { SessionService } from 'src/app/Services/session.service';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.css'],
})
export class MasterComponent implements OnInit, OnDestroy {
  @Output() EnableMenus: EventEmitter<any> = new EventEmitter();
  defaultLoginString: string = ``;

  navtext: string = 'bill';
  LocalEnv = 'https://perfectlearningapp.azurewebsites.net/'.trim();
  DevEnv = 'https://perfectlearningapp.azurewebsites.net/'.trim();
  appEnvironments: string = '';
  appEnvironment: string = '';
  envrnmtname: string = '';
  userRole: number = 0;
  user: any;
  Navigationflag: boolean = true;
  active_submenu: number = 0;
  Statusactive_submenu: number = 0;
  active_submenu1: number = 0;
  Statusactive_submenu1: number = 0;
  globalContentParams: any;
  idleState = 'Not started.';
  currentRoute: string = '';
  // timedOut = false;
  lastPing?: Date;
  SessionPopup: boolean = false;
  timedOut: boolean = false;
  constructor(
    private cookieService: CookieService,
    public _route: Router,
    public _appConfig: AppConfig,
    public toast: ToastrService,
    public appoffline: AppOfflineStore,
    private authService: AuthService,
    private idle: Idle,
    private keepalive: Keepalive,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    public service: ContentManagementService,
    private sessionService: SessionService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    $('#menu-toggle').click(function (e) {
      e.preventDefault();
      $('.dashboard-nav').toggleClass('mobile-show');
    });
    this.appEnvironment = this._appConfig.actionurl.trim();
    if (this.appEnvironments === 'http://localhost:58400/') {
      this.envrnmtname = '-local';
    } else if (
      this.appEnvironments === 'https://perfectlearningapp.azurewebsites.net'
    ) {
      this.envrnmtname = '-Dev';
    } else {
      this.envrnmtname = '-Dev';
    }
    this.defaultLoginString = `%C456UR102R@E12!N13384$TL^90924i456D1324AT??>:E+1340`;
    idle.setIdle(3000);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(3000);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.SessionPopup = false;
      this.idleState = 'No longer idle.';
    });
    idle.onTimeout.subscribe(() => {
      this.idleState =
        'Your Session has been Expired. Please Login to Proceed Further';
      this.timedOut = true;
      this.authService.logout();
      this.SessionPopup = true;
      AuthService.userSessionLogout.next();
      localStorage.setItem('Istimeout', 'true');
      // this.OnLogout();
    });
    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      this.SessionPopup = false;
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      AuthService.userSessionLogout.next();
      this.authService.logout();
      this.SessionPopup = true;
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(3000);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
    this.reset();
  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    this.SessionPopup = false;
  }
  private stopIdleTracking() {
  this.idle.stop();
  this.keepalive.stop();
  this.SessionPopup = false;
}

  ngAfterViewInit() {
    const mobileScreen = window.matchMedia('(max-width: 990px )');
    $(document).ready(function () {
      $('.dashboard-nav-dropdown-toggle').click(function () {
        $(this)
          .closest('.dashboard-nav-dropdown')
          .toggleClass('show')
          .find('.dashboard-nav-dropdown')
          .removeClass('show');
        $(this).parent().siblings().removeClass('show');
      });
      $('.menu-toggle').click(function () {
        if (mobileScreen.matches) {
          $('.dashboard-nav').toggleClass('mobile-show');
        } else {
          $('.dashboard').toggleClass('dashboard-compact');
        }
      });
      $('.dashboard-nav-dropdown-item').click(function () {
        if (mobileScreen.matches) {
          $('.dashboard-nav').toggleClass('mobile-show');
        } else {
          $('.dashboard').toggleClass('dashboard-compact');
        }
      });
      $('.dashboard-content').click(function () {
        if ($('.dashboard').hasClass('dashboard')) {
          $('.dashboard').addClass('dashboard dashboard-compact');
        }
      });
    });
  }
  enabletoggle: boolean = false;
  enabledisablemenu(): void {
    this.enabletoggle = !this.enabletoggle;
    if (this.enabletoggle === false) {
      this.enabletoggle1 = false;
    }
  }

  enabletoggle1: boolean = false;
  Menuexpand(): void {
    if (this.enabletoggle1 !== true) {
      this.enabletoggle1 = true;
    }
  }
  Role: string = 'SA';
  public ngOnInit() {
    $(document).ready(function () {
      $('.leftmenutrigger').on('click', function (e) {
        $('.side-nav').toggleClass('open');
        e.preventDefault();
      });
    });
    this._route.events.subscribe(() => {
      this.currentRoute = this._route.url;

      this.Role = localStorage.getItem('roles') || '';
      this.cdr.detectChanges();
      this.cdr.markForCheck();

    });
    this.service.queryParams$.subscribe((params: any) => {
      this.courseId = params?.c_id || '';

    });


    this.sessionService.serverSessionOut$.subscribe((res)=>{
      this.SessionPopup = false;
    });

    const params = this.route.queryParams.subscribe((params)=>{
    const c_id = params['c_id'] || this.globalContentParams?.c_id;
    this.courseId = c_id;
    })

    this.service.queryParams$.subscribe((params: any) => {
      this.globalContentParams = params;
    });

  }
  courseId:string =''
  private destroy$ = new Subject<void>();
  open(route: string, param?: string) {
    const params = this.route.snapshot.queryParams; // One-time read of query params
    const c_id = params['c_id'] || this.globalContentParams?.c_id;
    this.courseId = c_id;

    if (!c_id) {

            if(param){
      this._route.navigate([`${route}/${param}`], );
    }else{
        this._route.navigate([`${route}`], );
      }
    //   // If 'c_id' is missing, open the modal
    //   const modalRef = this.modalService.open(
    //     ContentManagementNavigatorComponent,
    //     {
    //       size: 'md',
    //       backdrop: 'static',
    //       centered: true, // Adjusted to include 'centered' option
    //     }
    //   );
    //   modalRef.componentInstance.route = route;
    //   modalRef.componentInstance.param = param;
    } else {
      // If 'c_id' exists, navigate with query parameters
      const navigationExtras: NavigationExtras = {
        queryParams: {
          c_id: params['c_id'] || this.globalContentParams?.c_id,
          eA_Name: params['eA_Name'] || this.globalContentParams?.eA_Name,
          c_Name: params['c_Name'] || this.globalContentParams?.c_Name,
          eY_Name: params['eY_Name'] || this.globalContentParams?.eY_Name,
          eA_Id: params['eA_Id'] || this.globalContentParams?.eA_Id,
          cM_id: params['cM_id'] || this.globalContentParams?.cM_id,
          cC_Code: params['cC_Code'] || this.globalContentParams?.cC_Code,
          cC_Name: params['cC_Name'] || this.globalContentParams?.cC_Name,
        },
        skipLocationChange: false,
      };
      if(param){
      this._route.navigate([`${route}/${param}`], navigationExtras);
    }else{
        this._route.navigate([`${route}`], navigationExtras);
      }
    }
  }
  goHome(){
    this._route.navigate(['/Admin/Dashboard']);
  }
  active1(i: number) {
    this.active_submenu1 = i;
    this.Statusactive_submenu1 = 0;
    this.active_submenu = 0;
    this.Statusactive_submenu = 0;
  }
  activestatus1(i: number) {
    this.Statusactive_submenu1 = i;
  }

  active(i: number) {
    this.active_submenu = i;
    this.Statusactive_submenu = 0;
    this.active_submenu1 = 0;
    this.Statusactive_submenu1 = 0;
  }
  activestatus(i: number) {
    this.Statusactive_submenu = i;
  }

  unactive() {
    this.active_submenu = 0;
    this.Statusactive_submenu = 0;
    this.active_submenu1 = 0;
    this.Statusactive_submenu1 = 0;
  }

  checkuser1(RoleID: any) {
    if (RoleID > 0) {
      let d: any;
      d = RoleID;
      return Number(d.RoleID);
    } else {
      return Number(0);
    }
  }

  checkuser() {
    return true;
    let data: any;
    data = this.userRole;
    return !(data && data.RoleID === 2);
  }
  menuID: Number = 0;
  flag: boolean = false;
  mouseEnter(menu: number, flag: boolean) {
    this.menuID = Number(menu);
    this.flag = flag;
    if (!this.menuID) {
      this.menuID = 0;
    }
    if (!this.flag) {
      this.flag = false;
    }
  }
  //signout
  sessionOut(){
    this.EnableMenus.emit(false);

    this.clickSignout();
    this.stopIdleTracking();
    this.authService.logout();
    this.modalService.dismissAll();
    this._route.navigate(['/login']);
  }
  signOut() {
    this.EnableMenus.emit(false);

    this.clickSignout();
    localStorage.removeItem('app:lastRoute');
    this.stopIdleTracking();
    this.authService.logout();
    this.modalService.dismissAll();
    this._route.navigate(['/login']);
  }

  signOutflag: boolean;
  clickSignout() {
    this.signOutflag = !this.signOutflag;
  }

  popupClose() {
    localStorage.setItem('Istimeout', 'false');
    this.SessionPopup = false;
  }
  ngOnDestroy() {
  this.stopIdleTracking(); // ⬅️ added
}
}
